<template>
  <div class="top">
    <el-row>
      <el-col :span="10">
        <div class="header">
          欢迎!
          <router-link :to="{ name: 'login' }" v-if="!isLogin"
            >请登录</router-link
          >
          <span class="activity_name" v-else>
            {{
              curActicity.activity && curActicity.activity.title
            }}
          </span>
          <!-- <router-link :to="{name:'register'}" v-if="!isLogin">注册</router-link> -->
          <!-- <router-link :to="{ name: '' }" v-if="!isLogin"></router-link> -->
          <span
            class="router_link"
            @click="showWrapper = true"
            v-if="isLogin && this.name !== 'history'"
          >
            切换活动
          </span>
          <span
            class="th-mall"
            v-if="
              isLogin &&
                hide &&
                hide.mallSwitch !== false &&
                this.name !== 'history'
            "
            @click="goPreference"
            >VIP特惠商城 低至6折起&gt;</span
          >
        </div>
      </el-col>
      <el-col :span="14" v-show="isLogin" class="user-wrap">
        <div v-if="endTime">
          <count-down class="count" :endTime="endTime"></count-down>
        </div>
        <a style="cursor: pointer" v-show="manual_link" @click="gotoshouce"
          >用户手册</a
        >
        <router-link :to="{ name: 'order-list' }">我的订单</router-link>
        <router-link :to="{ name: 'user-center' }">个人中心</router-link>
        <!-- <router-link :to="{name:'recharge'}">票券兑换</router-link> -->
        <span class="router_link" @click="logOut">退出登录</span>
      </el-col>
    </el-row>
    <div class="account_zhezhao_wrapper" v-show="showWrapper">
      <div>
        <el-row class="title">
          <el-col :span="10">请选择要进入的活动</el-col>
          <el-col :span="14">
            <i
              class="el-icon-close"
              v-if="showCancel"
              @click="
                showWrapper = false;
                tempActicity = curActicity;
              "
            ></i>
          </el-col>
        </el-row>
        <el-row class="activities">
          <el-col v-for="item in activities" :key="item.id">
            <span
              @click="tempActicity = item"
              :class="{ actived: tempActicity.activity_id == item.activity_id }"
            >
              <div>
                {{ item.activity && item.activity.title }}
              </div>
              <div class="balance">
                余额：{{ item.activity && item.remaining_balance }}
              </div>
              <div
                v-if="item.activity && item.activity.end_time"
                class="end_time"
              >
                到期时间:
                {{ item.activity && item.activity.end_time }}
              </div>
            </span>
          </el-col>
        </el-row>
        <el-row class="btn_wrap">
          <el-col :span="!showCancel ? 24 : 12">
            <el-button
              :class="{ 'btn-disabled': isDisabled }"
              @click="emit()"
              :disabled="isDisabled"
              >确 定</el-button
            >
          </el-col>
          <el-col :span="12" v-if="showCancel">
            <el-button
              @click="
                showWrapper = false;
                tempActicity = curActicity;
              "
              >取 消</el-button
            >
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import CountDown from "@/components/countdown/";

export default {
  name: "top-header-info",
  props: {
    state: String
  },
  components: {
    CountDown
  },
  data() {
    return {
      name: "",
      isLogin: false,
      curActicity: {
        activity: { announcement: {} },
        activity_id: "",
        title: ""
      },
      tempActicity: {},
      showWrapper: false,
      activities: [],
      showCancel: false,
      isDisabled: true,
      manual_link: null,
      interval: null,
      isDisabl: false,
      msg: "",
      endTime: null,
      hide: {}
    };
  },
  watch: {
    tempActicity: {
      handler(val) {
        if (!val) {
          this.isDisabled = true;
        } else {
          this.isDisabled = false;
        }
      }
    }
  },
  created() {
    this.name = window.sessionStorage.getItem("name");
  },
  mounted() {
    if (this.$util.getSessionStorage("Authorization").Authorization) {
      this.isLogin = true;
      if (this.$util.getSessionStorage("activityId").activityId) {
        setTimeout(() => {
          this.getData();
        }, 1000);
        if (this.$util.getSessionStorage("activity").activity) {
          this.curActicity = JSON.parse(
            this.$util.getSessionStorage("activity").activity
          );
        }
        if (!this.$util.getSessionStorage("isShow").isShow) {
          this.open();
          this.$util.setSessionStorage({
            isShow: 1
          });
        }
        this.tempActicity = this.curActicity;
        this.getActivityInfo();
        this.showCancel = true;
      }
      this.getActicities();
      this.getUsercenter_hide();
    } else {
      if (this.$route.path !== "/login" && this.$route.path !== "/forget") {
        this.$router.push({ path: "/login" });
      }
    }
    this.move();
  },
  methods: {
    gotoshouce() {
      window.open(this.manual_link);
    },
    open() {
      if (
        this.curActicity.activity.announcement &&
        this.curActicity.activity.announcement.detail
      ) {
        this.$alert(this.curActicity.activity.announcement.detail, {
          confirmButtonText: "确认,继续购物",
          lockScroll: true,
          dangerouslyUseHTMLString: true,
          customClass: "myAlertClass"
        });
      }
    },

    confirm() {
      this.$util.setSessionStorage({
        activityId: this.curActicity.activity_id,
        activityName: this.curActicity.activity.title,
        company: this.curActicity.company_id
      });
      // this.$bus.emit("choose-activity");
      this.$util.setSessionStorage({
        activity: JSON.stringify(this.curActicity)
      });
      // this.getActivityInfo(true);
    },
    emit() {
      if (sessionStorage.getItem("trace_info")) {
        sessionStorage.removeItem("trace_info");
      }
      if (sessionStorage.getItem("rn")) {
        sessionStorage.removeItem("rn");
      }
      this.curActicity = this.tempActicity;
      this.showWrapper = false;
      this.showCancel = true;
      this.confirm();
      // this.$bus.emit("get-cartNum");
      this.$util.removeSessionStorage("category");
      // this.getData();
      this.msg = this.curActicity.activity.announcement.detail;
      this.move();
      sessionStorage.removeItem("isShow");
      // this.getUsercenter_hide();
      location.reload();
    },

    move() {
      var that = this;
      this.msg = this.curActicity.activity.announcement.detail || "";
      this.interval = setInterval(function() {
        var start = that.msg.substring(0, 1);
        var end = that.msg.substring(1);
        that.isDisabl = true;
        that.msg = end + start;
      }, 400);
    },
    logOut() {
      this.$reqGet("api/passport/logout").then(() => {
        this.isLogin = false;
        this.$router.push({ name: "login" });
        this.$util.removeSessionStorage("Authorization");
        this.$util.removeSessionStorage("nick_name");
        this.$util.removeSessionStorage("user_id");
        this.$util.removeSessionStorage("avatar");
        this.$util.removeSessionStorage("activity");
        this.$util.removeSessionStorage("activityId");
        this.$util.removeSessionStorage("activityName");
        this.$util.removeSessionStorage("category");
        this.$util.removeSessionStorage("company");
        this.$util.removeSessionStorage("searchHistory");
        this.$util.removeSessionStorage("name");
        this.$util.removeSessionStorage("isShow");
      });
    },
    getData() {
      this.$reqGet("api/store/activities/" + this.curActicity.activity_id).then(
        res => {
          this.manual_link = res.data.data.products.manual_link;
          let currency_name = localStorage.getItem("currency_name");
          let currency_rate = localStorage.getItem("currency_rate");
          if (
            currency_name != res.data.data.currency_name ||
            currency_rate != res.data.data.rate
          ) {
            localStorage.setItem("currency_name", res.data.data.currency_name);
            localStorage.setItem("currency_rate", res.data.data.rate);
          }
        }
      );
    },
    getActicities() {
      this.$reqGet("api/usercenter/user_activity").then(res => {
        this.activities = res.data.data;
        this.activities.forEach(item => {
          let balance = parseFloat(item.balance);
          if (item.activity.rate) {
            balance = (balance * item.activity.rate).toFixed(2);
          }
          item.remaining_balance =
            item.activity.currency_name === "元"
              ? "￥" + balance
              : balance + item.activity.currency_name;
        });
        if (!sessionStorage.getItem("activityId")) {
          if (this.activities.length == 0) {
            this.showWrapper = false;
            this.name = "history";
            if (sessionStorage.getItem("name") === "history") {
              return;
            }
            // this.$confirm(
            //   "当前暂无任何福利,请联系管理员！您可以查看历史订单",
            //   "登录提醒",
            //   {
            //     confirmButtonText: "退出",
            //     cancelButtonText: "查看历史订单",
            //     cancelButtonClass: "canelBtn"
            //   }
            // )
            //   .then(() => {
            //     this.logOut();
            //   })
            //   .catch(() => {
            //     this.$router.push({
            //       path: "/userCenter-H",
            //       query: {
            //         name: "history"
            //       }
            //     });
            //   });
            this.goPreference();
            window.sessionStorage.setItem("name", "history");
            return;
          }
          this.$util.removeSessionStorage("name");
          if (this.activities.length == 1) {
            this.curActicity = this.activities[0];
            this.showCancel = true;
            this.showWrapper = false;
            this.tempActicity = this.curActicity;
            this.emit();
            return;
          }
          this.showWrapper = true;
        }
      });
    },
    // 获取当前活动信息
    getActivityInfo(flag) {
      const now_time = new Date();
      this.$reqGet("api/store/activities/" + this.curActicity.activity_id).then(
        res => {
          if (res.data.success) {
            if (flag) {
              this.$bus.emit("change-activity", res);
            }
            if (res.data.data.iso_end_time) {
              const endTime = res.data.data.iso_end_time;
              const current_time = res.data.data.current_time;
              const deff_time = (new Date() - now_time) / 2;
              const launch_time =
                deff_time +
                new Date(endTime).getTime() -
                new Date(current_time).getTime();
              this.endTime = new Date(now_time.getTime() + launch_time);
            } else {
              this.endTime = null;
            }
            this.$store.commit(
              "changePriceDisplay",
              res.data.data.products.price_display_discount
            );
            this.$store.commit(
              "changeHomePage",
              res.data.data.products.home_page_display_discount
            );
            this.$store.commit(
              "changeDiscountZone",
              res.data.data.products.discount_zone
            );
            // 活动状态
            if (res.data.data.message) {
              this.$alert(res.data.data.message, "提示", {
                confirmButtonText: "确定"
              });
              sessionStorage.setItem("activityMessage", res.data.data.message);
            } else {
              if (sessionStorage.getItem("activityMessage")) {
                sessionStorage.removeItem("activityMessage");
              }
            }

            this.$emit(
              "checkEcPlatformPrices",
              res.data.data.products.check_ec_platform_prices
            );
          }
        }
      );
    },
    getUsercenter_hide() {
      this.$reqGet("api/g/v1/company/config/usercenter_hide").then(res => {
        if (res.data.success) {
          this.hide = res.data.data.config;
        }
      });
    },
    goPreference() {
      this.$reqPost("api/store/reasonable-activity").then(res => {
        if (res.data.success) {
          this.$util.removeSessionStorage("activity");
          this.$util.removeSessionStorage("activityId");
          this.$util.removeSessionStorage("activityName");
          this.$util.removeSessionStorage("category");
          this.$util.removeSessionStorage("company");
          this.$util.removeSessionStorage("searchHistory");
          this.$util.setSessionStorage({
            activityId: res.data.data.id,
            activityName: res.data.data.activity.title,
            company: res.data.data.company_id
          });
          this.$util.setSessionStorage({
            activity: JSON.stringify({ activity: res.data.data })
          });
          location.reload();
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.top {
  width: 1200px;
  height: 34px;
  line-height: 34px;
  margin: 0 auto;
  a,
  .router_link {
    display: inline-block;
    margin-left: 10px;
    color: #999;
    cursor: pointer;
  }
  .user-wrap {
    display: flex;
    justify-content: flex-end;
  }
  .th-mall {
    color: red;
    cursor: pointer;
    margin-left: 5px;
  }
  .header {
    display: flex;
    align-items: center;
  }
  .activity_name {
    margin-left: 5px;
    max-width: 200px;
    white-space: nowrap; /* 防止文本换行 */
    overflow: hidden; /* 隐藏超出容器的部分文本 */
    text-overflow: ellipsis; /* 使用省略号来表示被隐藏的文本 */
  }
}
.account_zhezhao_wrapper {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9000;
  > div {
    width: 700px;
    min-height: 400px;
    background-color: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    padding: 15px;
    box-sizing: border-box;
    transform: translate(-50%, -50%);
    .title {
      font-size: 26px;
      color: #333;
      > .el-col:last-child {
        text-align: right;
        i {
          cursor: pointer;
        }
      }
    }
    .activities {
      max-height: 50vh;
      margin: 40px;
      overflow-y: auto;
      span {
        width: 500px;
        height: 70px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(200, 200, 200, 1);
        border-radius: 5px;
        margin: 0 auto;
        margin-bottom: 15px;
        cursor: pointer;
        position: relative;
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        line-height: 1;
        .balance {
          position: absolute;
          right: 20px;
          top: 50%;
          margin-top: -7px;
          color: rgba(222, 66, 34, 1);
        }
        .end_time {
          color: #999;
        }
        &.actived {
          background: rgba(252, 244, 243, 1);
          border: 1px solid rgba(222, 66, 34, 1);
        }
      }
    }
    .btn_wrap {
      padding: 10px 0;
      text-align: center;
      .el-button {
        width: 146px;
        height: 40px;
        border-radius: 5px;
        line-height: 40px;
        font-size: 16px;
        padding: 0;
        background: rgba(250, 250, 250, 1);
        border: 1px solid rgba(219, 219, 219, 1);
        color: #333;
      }
      .el-col:first-child {
        button {
          background: rgba(228, 57, 61, 1);
          border: 1px solid #e4393d;
          color: #fff;
        }
      }
    }
  }
}
.btn-disabled {
  color: #bdbdbd !important;
  cursor: not-allowed !important;
  background-image: none !important;
  background-color: #efefef !important;
  border-color: #ddd !important;
}
.notice {
  width: 370px;
  overflow: hidden;
  float: left;
  height: 30px;
}
.a {
  float: right;
}
</style>
<style>
.canelBtn {
  color: #fff !important;
  background-color: #409eff !important;
  border-color: #409eff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/top-header-info.vue